export default "__VITE_ASSET__338f4ca8__"